import React, { createContext, useContext } from 'react';
import type { AssistantBranding, AssistantStrings } from '../types';

export type AIAssistantConfigValue = {
  branding?: AssistantBranding;
  strings?: AssistantStrings;
  metaLine?: string;
};

const AIAssistantConfigContext = createContext<AIAssistantConfigValue | null>(null);

export function AIAssistantConfigProvider({
  value,
  children,
}: {
  value: AIAssistantConfigValue;
  children: React.ReactNode;
}) {
  return (
    <AIAssistantConfigContext.Provider value={value}>
      {children}
    </AIAssistantConfigContext.Provider>
  );
}

export function useAIAssistantConfig(): AIAssistantConfigValue | null {
  return useContext(AIAssistantConfigContext);
}
